import React from 'react'

function VenderManagement() {
  return (
    <div>Vender Management</div>
  )
}

export default VenderManagement